import { Calendar } from "lucide-react";

import {
    getNext7DaysET
} from "../../utils/timeUtils";

function DateSelector({
    selectedDate,
    setSelectedDate,
}) {

    const days =
        getNext7DaysET();

    return (

        <div style={styles.wrapper}>

            <div style={styles.header}>

                <Calendar
                    size={18}
                    color="#00f5a0"
                />

                <span style={styles.title}>
                    Next 7 Days
                </span>

            </div>

            <div style={styles.grid}>

                {days.map((day) => {

                    const active =
                        selectedDate === day.date;

                    return (

                        <button
                            key={day.date}
                            onClick={() =>
                                setSelectedDate(
                                    day.date
                                )
                            }
                            style={{
                                ...styles.dayButton,

                                ...(active
                                    ? styles.activeDay
                                    : {}),
                            }}
                        >

                            <div style={styles.dayName}>
                                {day.dayName}
                            </div>

                            <div style={styles.dayNum}>
                                {day.dayNum}
                            </div>

                            <div style={styles.month}>
                                {day.month}
                            </div>

                        </button>
                    );
                })}

            </div>

        </div>
    );
}

const styles = {

    wrapper: {

        background:
            "rgba(5, 15, 30, 0.88)",

        backdropFilter:
            "blur(14px)",

        border:
            "1px solid rgba(0,245,160,0.22)",

        borderRadius: "22px",

        padding: "24px",

        marginBottom: "35px",

        boxShadow:
            "0 10px 30px rgba(0,0,0,0.35)",
    },

    header: {

        display: "flex",

        alignItems: "center",

        gap: "10px",

        marginBottom: "22px",
    },

    title: {

        color: "#fff",

        fontSize: "18px",

        fontWeight: "600",
    },

    grid: {

        display: "grid",

        gridTemplateColumns:
            "repeat(7, 1fr)",

        gap: "12px",
    },

    dayButton: {

        background:
            "rgba(255,255,255,0.05)",

        border:
            "1px solid rgba(255,255,255,0.08)",

        borderRadius: "16px",

        padding: "16px 10px",

        cursor: "pointer",

        transition:
            "all 0.25s ease",

        color: "#d1d5db",
    },

    activeDay: {

        background:
            "linear-gradient(135deg, #00f5a0, #00d9f5)",

        color: "#001018",

        border:
            "1px solid transparent",

        boxShadow:
            "0 10px 25px rgba(0,245,160,0.28)",
    },

    dayName: {

        fontSize: "12px",

        marginBottom: "6px",

        fontWeight: "500",
    },

    dayNum: {

        fontSize: "24px",

        fontWeight: "bold",

        marginBottom: "4px",
    },

    month: {

        fontSize: "12px",

        opacity: 0.9,
    },
};

export default DateSelector;